import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Table, Button } from 'react-bootstrap';
import Moment from 'moment';
import Dialog from 'react-bootstrap-dialog';
import { Link } from 'react-router-dom';
import TooltipButton from './TooltipButton';
import TooltipLink from './TooltipLink';

Moment.locale('en');

class OrganisationTextLibrariesTable extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {}

    didConfirmDelete(textlibrary) {
        this.props.onDelete(textlibrary);
    }

    didSaveChanges(textlibrary, newName) {
        this.props.onSave(textlibrary, newName);
    }

    handleDeleteClicked(textlibrary) {
        const { t } = this.props;

        this.dialog.show({
            title: t('Dialog.warning'),
            body: t('Dialog.sure_deletion'),
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => console.log('Cancel!'),
                    'btn-default'
                ),
                Dialog.Action(
                    t('Dialog.delete'),
                    () => this.didConfirmDelete(textlibrary),
                    'btn-danger'
                )
            ],
            bsSize: 'large',
            onHide: dialog => {
                dialog.hide();
            }
        });
    }

    handleEditClicked(textlibrary) {
        const { t } = this.props;

        this.dialog.show({
            body: t('OrganisationTextLibrariesTable.textlibrary_name'),
            prompt: Dialog.TextPrompt({
                placeholder: t('OrganisationTextLibrariesTable.name'),
                initialValue: textlibrary.name
            }),
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => console.log('Cancel!'),
                    'btn-default'
                ),
                Dialog.Action(
                    t('Dialog.save'),
                    dialog => this.didSaveChanges(textlibrary, dialog.value),
                    'btn-danger'
                )
            ],
            bsSize: 'large',
            onHide: dialog => {
                dialog.hide();
            }
        });
    }

    render() {
        const { t, uuid } = this.props;
        let textlibraryRows = this.props.textlibraries.map(
            (textlibrary, index) => {
                return (
                    <tr key={index}>
                        <td>
                            <Link
                               style={{
                                alignItems: "center",
                                textAlign: "left"
                              }}
                             className="label label-primary"
                                to={`/organisations/${uuid}/textlibraries/${
                                    textlibrary.uuid
                                }?rel=library`}
                            >
                                <i className={'fa fa-font'} />{' '}
                                {textlibrary.name}{' '}
                            </Link>{' '}
                        </td>{' '}
                        <td className="hidden-xs">
                            {' '}
                            {Moment(textlibrary.updatedAt).format(
                                'YYYY-MM-DD HH:mm'
                            )}{' '}
                        </td>{' '}
                        <td className="hidden-xs">
                            {' '}
                            {Moment(textlibrary.createdAt).format(
                                'YYYY-MM-DD HH:mm'
                            )}{' '}
                        </td>{' '}
                        <td align="center">
                            <TooltipButton
                                id="editButton"
                                className="btn-default pull-left"
                                onClick={() =>
                                    this.handleEditClicked(textlibrary)
                                }
                                tooltip={t(
                                    'OrganisationTextLibrariesTable.edittextlibrary'
                                )}
                            >
                                <em className="fas fa-pencil-alt" />
                            </TooltipButton>{' '}
                            {this.props.userIsAuthorized(this.props.user, [
                                'staff_super_admin',
                                'staff_admin',
                                'organisation_admin',
                                'organisation_user'
                            ]) ? (
                                <TooltipButton
                                    id="deleteButton"
                                    className="btn-danger pull-right"
                                    tooltip={t(
                                        'OrganisationTextLibrariesTable.deletetextlibrary'
                                    )}
                                    onClick={() =>
                                        this.handleDeleteClicked(textlibrary)
                                    }
                                >
                                    <em className="fa fa-trash" />
                                </TooltipButton>
                            ) : null}
                        </td>{' '}
                    </tr>
                );
            }
        );

        return (
            <div
                id="OrganisationTextLibrariesTable"
                className="OrganisationTextLibrariesTable"
            >
                <Dialog
                    ref={el => {
                        this.dialog = el;
                    }}
                />{' '}
                <Table striped bordered condensed hover>
                    <thead>
                        <tr>
                            <th>
                                {' '}
                                {t('OrganisationTextLibrariesTable.name')}{' '}
                            </th>{' '}
                            <th className="hidden-xs">
                                {' '}
                                {t(
                                    'OrganisationTextLibrariesTable.updated'
                                )}{' '}
                            </th>{' '}
                            <th className="hidden-xs">
                                {' '}
                                {t(
                                    'OrganisationTextLibrariesTable.created'
                                )}{' '}
                            </th>{' '}
                            <th>
                                <em className="fa fa-cog" />
                            </th>{' '}
                        </tr>{' '}
                    </thead>{' '}
                    <tbody> {textlibraryRows} </tbody>{' '}
                </Table>{' '}
            </div>
        );
    }
}

export default translate('translations')(OrganisationTextLibrariesTable);
